"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames4 = _interopRequireDefault(require("classnames"));
var _helpers = require("../../helpers.js");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Component = /*#__PURE__*/function (_React$Component) {
  _inherits(Component, _React$Component);
  var _super = _createSuper(Component);
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "scrollToSelected", function (prevProps) {
      var _this$props = _this.props,
        selectedFile = _this$props.selectedFile,
        selectedFolder = _this$props.selectedFolder;
      if (selectedFile === prevProps.selectedFile && selectedFolder === prevProps.selectedFolder) {
        return;
      }
      var selectedItems = _this.wrapper.getElementsByClassName(_style["default"].selected);
      if (selectedItems.length !== 1) {
        return;
      }
      selectedItems[0].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var keys = {
        BACKSPACE: 8,
        ENTER: 13,
        SPACE: 32,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40
      };
      var _this$props2 = _this.props,
        selectedFile = _this$props2.selectedFile,
        selectedFolder = _this$props2.selectedFolder,
        selectedFolderUp = _this$props2.selectedFolderUp;
      var wrapperWidth = _this.wrapper.clientWidth;
      var childWidth = _this.wrapper.firstElementChild.offsetWidth;
      var childGap = childWidth / 9 * 0.8;
      var numberPerRow = Math.floor((wrapperWidth + childGap) / (childWidth + childGap));
      if (Object.values(keys).includes(e.keyCode)) {
        e.preventDefault();
      }
      switch (e.keyCode) {
        case keys.ENTER:
          {
            if (selectedFolderUp) {
              _this.props.goFolderUp();
            } else if (selectedFolder) {
              _this.props.goToFolder(selectedFolder.id);
            }
            break;
          }
        case keys.BACKSPACE:
          _this.props.goFolderUp();
          break;
        case keys.LEFT:
          _this.props.selectNext(-1);
          break;
        case keys.RIGHT:
          _this.props.selectNext(1);
          break;
        case keys.UP:
          _this.props.selectNext(-numberPerRow);
          break;
        case keys.DOWN:
          _this.props.selectNext(numberPerRow);
          break;
        case keys.SPACE:
          {
            if (selectedFile || selectedFolder) {
              _this.props.showInfoModal(true);
            }
            break;
          }
        default:
          break;
      }
    });
    return _this;
  }
  _createClass(Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.scrollToSelected.apply(this, arguments);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$currentFo = this.props.currentFolderData,
        folders = _this$props$currentFo.folders,
        files = _this$props$currentFo.files;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].wrapper,
        ref: function ref(elem) {
          _this2.wrapper = elem;
        }
      }, !this.props.isTopFolder && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames4["default"])(_style["default"].item, _defineProperty({}, _style["default"].selected, this.props.selectedFolderUp)),
        onClick: this.props.selectFolder.bind(null, -1),
        onDoubleClick: this.props.goFolderUp,
        "data-folder": true
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].thumbnail + ' ' + _style["default"].folderUp
      }), /*#__PURE__*/_react["default"].createElement("div", null, "..")), folders.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: item.id,
          className: (0, _classnames4["default"])(_style["default"].item, _defineProperty({}, _style["default"].selected, _this2.props.selectedFolders.includes(item.id))),
          onClick: _this2.props.selectFolder.bind(null, item.id),
          onDoubleClick: _this2.props.goToFolder.bind(null, item.id),
          "data-folder": true
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].thumbnail + ' ' + _style["default"].folder
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "text-center"
        }, (0, _helpers.reduceLength)(item.name, 30)));
      }), files.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: item.id,
          className: (0, _classnames4["default"])(_style["default"].item, _defineProperty({}, _style["default"].selected, _this2.props.selectedFiles.includes(item.id))),
          onClick: _this2.props.selectFile.bind(null, item.id),
          "data-file": true
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].thumbnail,
          style: {
            backgroundImage: "url(".concat(item.thumbnailSmall, ")")
          }
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "text-center"
        }, (0, _helpers.reduceLength)(item.name, 30)));
      }));
    }
  }]);
  return Component;
}(_react["default"].Component);
exports["default"] = Component;
_defineProperty(Component, "propTypes", {
  currentFolderId: _propTypes["default"].number,
  currentFolderData: _propTypes["default"].object,
  selectedFolderUp: _propTypes["default"].bool,
  selectedFiles: _propTypes["default"].array,
  selectedFolders: _propTypes["default"].array,
  selectedFile: _propTypes["default"].object,
  selectedFolder: _propTypes["default"].object,
  goToFolder: _propTypes["default"].func,
  goFolderUp: _propTypes["default"].func,
  selectFile: _propTypes["default"].func,
  selectFolder: _propTypes["default"].func,
  selectNext: _propTypes["default"].func,
  showInfoModal: _propTypes["default"].func,
  isTopFolder: _propTypes["default"].bool
});